import * as React from 'react';
import EstimationPeriodModel from '../../domain/EstimationPeriod';
import EstimationPeriod from './EstimationPeriod';
import State from '../../application/core/State';
import { connect } from 'react-redux';
import './Estimations.css';
import DispatchProps, { mapDispatchToProps } from '../../application/core/DispatchProps';
import EstimationPeriodsRequested from '../../application/admin/events/EstimationPeriodGetRequested';

interface StateProps {
    estimationPeriod?: EstimationPeriodModel;
}

class Estimations extends React.PureComponent<StateProps & DispatchProps> {
    public componentDidMount(): void {
        this.props.dispatch(new EstimationPeriodsRequested());
    }

    public render(): JSX.Element {
        return (
            <div>
                {!this.props.estimationPeriod ? (
                    <span>loading...</span>
                ) : (
                    <EstimationPeriod estimationPeriod={this.props.estimationPeriod} />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: State): StateProps => ({
    estimationPeriod: state.admin.estimationPeriod
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Estimations);



// WEBPACK FOOTER //
// ./src/view/admin/Estimations.tsx